export default "__VITE_PUBLIC_ASSET__95cbb166__"